import PageLayout from 'pages/Login/PageLayout';
import PageProvider from 'pages/Login/PageProvider';

const LoginPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default LoginPage;
